import React from "react";

class ErrorBoundary extends React.Component {
	constructor(props) {
		super(props);
		this.state = { hasError: false, error: null, errorInfo: null };
	}

	static getDerivedStateFromError(error) {
		return { hasError: true };
	}

	componentDidCatch(error, errorInfo) {
		console.error("ErrorBoundary caught an error:", error, errorInfo);
		this.setState({
			error: error,
			errorInfo: errorInfo,
		});
	}

	render() {
		if (this.state.hasError) {
			return (
				<div className="mx-auto w-full max-w-2xl p-4">
					<div className="rounded-lg border border-red-200 bg-red-50 p-6 dark:border-red-800 dark:bg-red-900/20">
						<h2 className="mb-4 text-xl font-bold text-red-800 dark:text-red-200">
							Something went wrong
						</h2>
						<details className="text-sm text-red-700 dark:text-red-300">
							<summary className="mb-2 cursor-pointer font-medium">
								Error details
							</summary>
							<pre className="mt-2 overflow-auto rounded bg-red-100 p-4 dark:bg-red-900/40">
								{this.state.error && this.state.error.toString()}
								{"\n\n"}
								{this.state.errorInfo && this.state.errorInfo.componentStack}
							</pre>
						</details>
						<button
							onClick={() => window.location.reload()}
							className="mt-4 rounded-lg bg-red-600 px-4 py-2 text-white hover:bg-red-700"
						>
							Reload Page
						</button>
					</div>
				</div>
			);
		}

		return this.props.children;
	}
}

export default ErrorBoundary;
